module.exports = __webpack_public_path__ + "static/the-end-of-the-daily-commute-0a139c7d43c1e7c0a91df757f3425de1.png";